import { AnimatePresence, motion } from 'framer-motion';
import styled from 'styled-components';

export const AnimatedRadio = ({ checked }: { checked: boolean }) => {
  return (
    <AnimatePresence initial={false}>
      <Svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {checked ? (
          <motion.path
            d="M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm8-10C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 15a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z"
            fill="currentColor"
            animate={{ scale: 1, transition: { duration: 0.2 } }}
            initial={{ scale: checked ? 0.85 : 1 }}
          />
        ) : (
          <path
            d="M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Z"
            fill="currentColor"
          />
        )}
      </Svg>
    </AnimatePresence>
  );
};

const Svg = styled.svg({
  flexShrink: 0,
});
